import { render, staticRenderFns } from "./OnlineTestReports.vue?vue&type=template&id=a43993da&scoped=true&"
import script from "./OnlineTestReports.vue?vue&type=script&lang=js&"
export * from "./OnlineTestReports.vue?vue&type=script&lang=js&"
import style0 from "./OnlineTestReports.vue?vue&type=style&index=0&id=a43993da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a43993da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VDataTable,VImg,VSelect,VTextField})
